import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppError, AuthSelector, CoreState, DEPOSIT_LIMIT_ACTION_TYPE, MessageService } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, tap, withLatestFrom } from "rxjs/operators";

import { DepositLimitCalculatorAction } from "./deposit-limit-calculator.action";
import { DEPOSIT_LIMIT_CALCULATOR_MESSAGE_CONTEXT } from "./deposit-limit-calculator.const";
import { DepositLimitCalculatorService } from "./deposit-limit-calculator.service";

@Injectable()
export class DepositLimitCalculatorEffect {
	depositLimitUpdated$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(DEPOSIT_LIMIT_ACTION_TYPE.updateSuccess),
				tap(() => this.service.deletePredictions())
			),
		{ dispatch: false }
	);

	getPredictions$ = createEffect(() =>
		this.actions$.pipe(
			ofType(DepositLimitCalculatorAction.getPredictions),
			withLatestFrom(this.store.select(AuthSelector.getSessionToken)),
			filter((sessionToken) => !!sessionToken[1]),
			switchMap((sessionToken) =>
				this.service.fetchPredictions(sessionToken[1]).pipe(
					map((predictionsResponse) =>
						DepositLimitCalculatorAction.getPredictionsSuccess(predictionsResponse)
					),
					catchError((error: AppError) => of(DepositLimitCalculatorAction.getPredictionsFail(error)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		this.messageService.mapErrorByContext$({
			[DepositLimitCalculatorAction.getPredictionsFail.type]:
				DEPOSIT_LIMIT_CALCULATOR_MESSAGE_CONTEXT.getPredictions,
		})
	);

	constructor(
		private actions$: Actions,
		private service: DepositLimitCalculatorService,
		private store: Store<CoreState>,
		private messageService: MessageService
	) {}
}
